import { ReactElement, ReactNode } from 'react';
import { ContainerCard } from '../ContainerCard/ContainerCard';
import classes from './StatsCard.module.css';

export type StatsCardConfig = {
  readonly title: string;
  readonly icon?: ReactNode;
  readonly value: number | string;
  readonly meta?: string;
  readonly formatter?: (value: number | string) => string;
};

type StatsCardProps = {
  readonly config: StatsCardConfig;
};

const defaultFormatter = (value: number | string): string => {
  return typeof value === 'number' ? value.toString() : value;
};

export const StatsCard = ({ config }: StatsCardProps): ReactElement => {
  const formatter = config.formatter || defaultFormatter;
  const displayValue = formatter(config.value);

  return (
    <ContainerCard>
      <ContainerCard.Title icon={config.icon}>{config.title}</ContainerCard.Title>
      <ContainerCard.Body className={classes.body}>
        <div className={classes.value}>{displayValue}</div>
        {config.meta && <div className={classes.meta}>{config.meta}</div>}
      </ContainerCard.Body>
    </ContainerCard>
  );
};

type StatsCardsGridProps = {
  readonly cards: readonly StatsCardConfig[];
  readonly columns?: 2 | 3 | 4;
};

export const StatsCardsGrid = ({ cards, columns = 4 }: StatsCardsGridProps): ReactElement => {
  const gridClassName = `${classes.grid} ${classes[`grid--${columns}col`]}`;

  return (
    <div className={gridClassName}>
      {cards.map((card) => (
        <StatsCard key={card.title} config={card} />
      ))}
    </div>
  );
};
